import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';
import { BlockCinemaMap } from './styles';

const propTypes = {
  google: PropTypes.shape({
    maps: PropTypes.object.isRequired
  }).isRequired,
  geo: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired
  }),
  name: PropTypes.string,
  address: PropTypes.string,
  mapRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired
};

const defaultProps = {
  geo: {
    latitude: 0,
    longitude: 0
  },
  name: '',
  address: ''
};

const BlockMap = ({ google, geo, name, address, mapRef }) => {
  const coords = {
    lat: geo.latitude,
    lng: geo.longitude
  };
  const [isInfoWindow, toggleInfoWindow] = useState(false);
  const [activeMarker, setActiveMarker] = useState(null);

  const onMarkerClick = (props, marker) => {
    setActiveMarker(marker);
    toggleInfoWindow(true);
  };

  const onMapClicked = () => {
    if (isInfoWindow) {
      setActiveMarker(null);
      toggleInfoWindow(false);
    }
  };

  return (
    <BlockCinemaMap className="b-cinema__map" ref={mapRef}>
      <Map
        google={google}
        style={{ height: '360px' }}
        zoom={15}
        initialCenter={coords}
        center={coords}
        onClick={onMapClicked}
      >
        <Marker title={name} position={coords} onClick={onMarkerClick} />

        <InfoWindow visible={isInfoWindow} marker={activeMarker}>
          <div className="b-cinema__map-info">
            <h5>{name}</h5>
            <p>{address}</p>
          </div>
        </InfoWindow>
      </Map>
    </BlockCinemaMap>
  );
};

BlockMap.propTypes = propTypes;
BlockMap.defaultProps = defaultProps;
export default GoogleApiWrapper(({ apiKey }) => ({ apiKey }))(BlockMap);
